import { memo } from 'react';

import { cn } from '../../../lib/cn';
import type { BadgeColorConfig } from '../types';

interface BadgeCellProps {
  value: string | null | undefined;
  colorMap?: Record<string, BadgeColorConfig>;
  className?: string;
}

const defaultColorMap: Record<string, BadgeColorConfig> = {
  active: { bg: 'bg-green-100', text: 'text-green-800' },
  inactive: { bg: 'bg-slate-100', text: 'text-slate-600' },
  suspended: { bg: 'bg-red-100', text: 'text-red-800' },
  pending: { bg: 'bg-amber-100', text: 'text-amber-800' },
};

export const BadgeCell = memo(function BadgeCell({
  value,
  colorMap,
  className,
}: BadgeCellProps) {
  if (value === null || value === undefined) {
    return <span className="text-slate-400">-</span>;
  }

  const resolvedMap = colorMap ?? defaultColorMap;
  const config = resolvedMap[value];

  if (!config) {
    return (
      <span
        className={cn(
          'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium bg-slate-100 text-slate-700',
          className,
        )}
      >
        {value}
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        config.bg,
        config.text,
        className,
      )}
    >
      {config.label ?? value}
    </span>
  );
});
